import React from 'react';
import { AspectRatio, Box, Flex, ModalBody } from '@stockx/ui';
import { ChevronLeftIcon, ChevronRightIcon } from '@stockx/icons';
import UserGeneratedContentCreatorHeader from '../UserGeneratedContentCreatorHeader';
import UserGeneratedContentImageLabel from '../UserGeneratedContentImageLabel';
import UserGeneratedContentModalContent from '../UserGeneratedContentModalContent';
import { StyledModalArrowStyles } from '../UserGeneratedContentModal.styles';
import UserGeneratedContentSocialLinks from '../UserGeneratedContentSocialLinks';
import UserGeneratedContentModalImage from '../UserGeneratedContentModalImage';

const UserGeneratedContentModalMobile = ({
  entry,
  styles,
  handleTouchStart,
  handleTouchMove,
  canMoveLeft,
  canMoveRight,
  handleOnClick,
}) => {
  const { creator, creatorProfilePhoto } = entry;

  return (
    <ModalBody
      sx={styles.body}
      overflowY="auto"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <Box mt="-28px">
        <UserGeneratedContentCreatorHeader
          creator={creator}
          creatorProfilePhoto={creatorProfilePhoto}
        />
      </Box>
      <Box mt={3} ml={-6} mr={-6} position="relative">
        <UserGeneratedContentImageLabel creator={entry?.creator} />
        <AspectRatio ratio={1}>
          <UserGeneratedContentModalImage imageUrl={entry?.image?.url} />
        </AspectRatio>
        {canMoveLeft ? (
          <Box
            sx={StyledModalArrowStyles.variants['leftMobile']}
            onClick={() => handleOnClick('left')}
          >
            <ChevronLeftIcon color="black" boxSize="6" />
          </Box>
        ) : null}
        {canMoveRight ? (
          <Box
            sx={StyledModalArrowStyles.variants['rightMobile']}
            onClick={() => handleOnClick('right')}
          >
            <ChevronRightIcon color="black" boxSize="6" />
          </Box>
        ) : null}
      </Box>
      <Box mt={7}>
        <UserGeneratedContentModalContent entry={entry} />
      </Box>
      <Flex
        w="100%"
        h="15"
        backgroundColor="white"
        alignItems="center"
        justifyContent="flex-end"
      >
        <UserGeneratedContentSocialLinks />
      </Flex>
    </ModalBody>
  );
};

export default UserGeneratedContentModalMobile;
